import { lazy } from "react";
import Loadable from "../components/Loadable";
import DashboardLayout from "../layout/Dashboard";
//import StripeElements from "../../components/StripeElements";

// Import the new Question components
const Questions = Loadable(lazy(() => import("../pages/admin/Ai/Questions")));
const QuestionEdit = Loadable(lazy(() => import("../pages/admin/Ai/QuestionEdit")));

const StripeElements = Loadable(lazy(() => import("../../components/StripeElements")));
const GeneralSetting = Loadable(lazy(() => import("../pages/admin/other/GeneralSetting")));
const PageList = Loadable(lazy(() => import("../pages/admin/static-page/PageList")));
const Prompts = Loadable(lazy(() => import("../pages/admin/Ai/Prompts")));
const PromptEdit = Loadable(lazy(() => import("../pages/admin/Ai/PromptEdit")));
const Employer = Loadable(lazy(() => import("../pages/admin/Employer")));
const Transactions = Loadable(lazy(() => import("../pages/common/Transactions")));
const EmployerAllJob = Loadable(lazy(() => import("../pages/admin/employer/EmployerAllJob")));
const Profile = Loadable(lazy(() => import("../../front/pages/Profile")));
const EmployerAllJobDetails = Loadable(lazy(() => import("../pages/admin/employer/EmployerAllJobDetails")));
const ShootJobMail = Loadable(lazy(() => import("../pages/admin/ShootJobMail")));
const HomePage = Loadable(lazy(() => import("../pages/admin/other/HomePage")));
const JobDetails = Loadable(lazy(() => import("../../front/pages/JobDetails")));
const Agreement = Loadable(lazy(() => import("../pages/admin/Agreement")));
const AdminSubscriptions = Loadable(lazy(() => import("../pages/admin/AdminSubscriptions")));
const InitialAgreement = Loadable(lazy(() => import("../pages/admin/InitialAgreement")));
const AffiliateCommissions = Loadable(lazy(() => import("../pages/admin/affiliate/AffiliateCommissions")));
const Notifications = Loadable(lazy(() => import("../pages/common/Notifications")));
const Users = Loadable(lazy(() => import("../pages/admin/users/Users")));
const ChangePassword = Loadable(lazy(() => import("../pages/common/ChangePassword")));
const Subscriptions = Loadable(lazy(() => import("../pages/common/subscription/Subscriptions")));
const PaymentMethods = Loadable(lazy(() => import("../pages/common/PaymentMethods")));
const CurrentPlan = Loadable(lazy(() => import("../pages/common/CurrentPlan")));
const DashboardDefault = Loadable(lazy(() => import("../pages/dashboard/index")));
const Seo = Loadable(lazy(() => import("../pages/admin/Seo")));
const ContactQuery = Loadable(lazy(() => import("../pages/admin/other/ContactQuery")));
const BlogList = Loadable(lazy(() => import("../pages/admin/blog/BlogList")));

const PaymentMethodsWithStripe = () => (
  <StripeElements>
    <PaymentMethods />
  </StripeElements>
);

const SubscriptionsWithStripe = () => (
  <StripeElements>
    <Subscriptions />
  </StripeElements>
);

const MainRoutes = {
  path: `/admin`,
  element: <DashboardLayout />,
  children: [
    {
      path: "",
      element: <DashboardDefault />,
    },
    {
      path: "dashboard",
      element: <DashboardDefault />,
    },
    {
      path: "notifications",
      element: <Notifications />,
    },
    {
      path: "general-settings",
      element: <GeneralSetting />,
    },
    {
      path: "agreement",
      element: <Agreement />,
    },
    {
      path: "final-agreement",
      element: <InitialAgreement />,
    },
    {
      path: "job-details/:jobId",
      element: <JobDetails />,
    },
    {
      path: "home-page",
      element: <HomePage />,
    },
    {
      path: "transactions",
      element: <Transactions />,
    },
    {
      path: "employerAllJob",
      element: <EmployerAllJob />,
    },
    {
      path: "shootJobmail",
      element: <ShootJobMail />,
    },
    {
      path: "employerAllJobDetails/:id?",
      element: <EmployerAllJobDetails />,
    },
    {
      path: "user/:role?",
      element: <Employer />,
    },
    {
      path: "commissions/:status?",
      element: <AffiliateCommissions />,
    },
    {
      path: "profile",
      element: <Profile />,
    },
    {
      path: "subscriptions/",
      element: <SubscriptionsWithStripe />,
    },
    {
      path: "blog",
      element: <BlogList />,
    },
    {
    },
    {
      path: "management/:role",
      element: <Users />,
    },
    {
      path: "change-password",
      element: <ChangePassword />,
    },
    {
      path: "payment-methods",
      element: <PaymentMethodsWithStripe />,
    },
    {
      path: "current-plan",
      element: <CurrentPlan />,
    },
    {
      path: "user-subscriptions",
      element: <AdminSubscriptions />,
    },
    {
      path: "seo",
      element: <Seo />,
    },
    {
      path: "contact-query",
      element: <ContactQuery />
    },
    {
      path: "prompts",
      element: <Prompts />
    },
    {
      path: "prompts/edit/:role?",
      element: <PromptEdit />
    },
    {
      path: "general-setting",
      element: <GeneralSetting />,
    },
    {
      path: "static-pages",
      element: <PageList />,
    },
    // New question management routes
    {
      path: "questions",
      element: <Questions />,
    },
    {
      path: "questions/edit",
      element: <QuestionEdit />,
    },
    {
      path: "questions/edit/:id",
      element: <QuestionEdit />,
    },
  ],
};

export default MainRoutes;
